var exports = {
  "iE": "EmbedCard.module__wrapper___RWVSVT",
  "p_": "EmbedCard.module__splashWrapper___RWVSVT",
  "Yi": "EmbedCard.module__splash___RWVSVT",
  "Vg": "EmbedCard.module__grid___RWVSVT",
  "iA": "EmbedCard.module__iconSlot___RWVSVT",
  "Qs": "EmbedCard.module__content___RWVSVT",
  "wx": "EmbedCard.module__header___RWVSVT",
  "$": "EmbedCard.module__titleRow___RWVSVT",
  "VA": "EmbedCard.module__subtitle___RWVSVT",
  "rf": "EmbedCard.module__body___RWVSVT",
  "yF": "EmbedCard.module__divider___RWVSVT",
  "DD": "EmbedCard.module__title___RWVSVT",
  "N4": "EmbedCard.module__titleButton___RWVSVT",
  "jn": "EmbedCard.module__titlePrimary___RWVSVT",
  "S3": "EmbedCard.module__titleDanger___RWVSVT",
  "BK": "EmbedCard.module__helpText___RWVSVT",
  "_O": "EmbedCard.module__iconCircleDisabled___RWVSVT",
  "m5": "EmbedCard.module__iconError___RWVSVT",
  "qV": "EmbedCard.module__skeleton___RWVSVT",
  "U6": "EmbedCard.module__pulse___RWVSVT",
  "mj": "EmbedCard.module__skeletonCircle___RWVSVT",
  "Iz": "EmbedCard.module__skeletonTitle___RWVSVT",
  "wS": "EmbedCard.module__skeletonSubtitle___RWVSVT",
  "VR": "EmbedCard.module__skeletonIcon___RWVSVT",
  "X1": "EmbedCard.module__skeletonDot___RWVSVT",
  "gH": "EmbedCard.module__skeletonStat___RWVSVT",
  "Ye": "EmbedCard.module__skeletonStatShort___RWVSVT",
  "KJ": "EmbedCard.module__skeletonStatLong___RWVSVT",
  "G3": "EmbedCard.module__skeletonButton___RWVSVT",
};

module.exports = exports;
